module.exports = __webpack_public_path__ + "img/closed-right.d44d3dc0.svg";